import { Component, Input, HostListener, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  encapsulation: ViewEncapsulation.Emulated  // Asegura que los estilos sean específicos para este componente
})
export class CarouselComponent implements OnInit {
  @ViewChild('carouselContainer') carouselContainer: ElementRef;
  @Input() cards: any[] = [];
  @Input() cant: number = 4; // Cantidad máxima de cards por vista
  isDesktop: boolean = true;
  currentIndex: number = 0;
  lockedLeft = true;
  lockedRight = false;
  componentId = 'carousel-' + Math.random().toString(36).substring(7);
  carouselTransform: string = 'translateX(0)';  // Propiedad vinculada para el desplazamiento

  ngOnInit(): void {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isDesktop = window.innerWidth > 768;
    this.cant = (this.isDesktop) ? 4 : 1;
  }

  // Mover a la izquierda
  moveLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1; // Mover el índice según el valor de 'cant'
      this.updateCarouselPosition();
    }

    // Bloquear flecha izquierda si estamos en el primer conjunto
    this.lockedLeft = this.currentIndex === 0;
    this.lockedRight = false; // Desbloquear flecha derecha
  }

  // Mover a la derecha
  moveRight() {
    if (this.currentIndex + this.cant < this.cards.length) {
      this.currentIndex += 1; // Mover el índice según el valor de 'cant'
      this.updateCarouselPosition();
    }

    // Bloquear flecha derecha si ya no hay más elementos
    this.lockedRight = this.currentIndex + this.cant >= this.cards.length;
    this.lockedLeft = false; // Desbloquear flecha izquierda
  }

  // Actualizar la posición del carrusel usando transform
  updateCarouselPosition() {
    // Calcula el desplazamiento en porcentaje
    const cardWidth = 100 / this.cant;  // El ancho de cada card en porcentaje
    const offset = this.currentIndex * cardWidth;  // Desplazamiento total basado en el índice
    this.carouselTransform = `translateX(-${offset}%)`;  // Actualiza el estilo de transform
  }

}
